import React from 'react';
import BaseContainer from '../../baseContainers/BaseContainer';
import BlockUi from '../../components/waitPanel/BlockUi';
import BaseBreadCrumb from '../../baseContainers/BaseBreadCrumb';
import CompanyAgreementBanner from '../../components/CompanyAgreementBanner';
import {DashboardCardMonthComponent} from './DashboardCardMonthComponent';
import DashboardCardChartComponent from './DashboardCardChartComponent';
import StatisticService from '../../services/StatisticService';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InternalUserService from '../../services/MobileUserService';
import DashboardRankComponent from './DashboardRankComponent';
import RankingService from '../../services/RankingService';
import TransportService from '../../services/TransportService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import { t } from 'i18next';
import DashboardCardMapComponentV2 from './DashboardCardMapComponentV2';
import CompanyTransportService from '../../services/CompanyTransportService';
import FullScreenMapDialog from '../../components/FullScreenMapDialog';
import FullScreenMapComponent from './FullScreenMapComponent';

class DashboardContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            monthTravelKilometers: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            monthSavedCo2: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            monthFinishedChallengesCount: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            transportTypes: [],
            renderMap: false,
            rankingPageable: [],
            // todayRoutes: {
            //     coordinates: [],
            // },
            todayRoutes: [],
            kilometersGroupedByMonths: undefined,
            savedCo2GroupedByMonths: undefined,
            fullScreenMapVisible: false,
        };

        this.statisticService = new StatisticService();
        this.transportService = new TransportService();
        this.companyTransportService = new CompanyTransportService();
        this.rankingService = new RankingService();
        // TODO:  to tak srednio chyba ze nazywa sie internal

        this.mobileUserService = new InternalUserService();
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchMonthTravelKilometers();
        this.fetchSavedCo2();
        this.fetchTodayCoordinates();
        this.fetchKilometerGroupByMonths();
        this.fetchSavedCo2GroupByMonths();
        this.fetchMonthFinishedChallengesCount();
        this.fetchTransportDictTypes();
    }
    fetchTransportDictTypes = () => {
        this.companyTransportService
            .getTransportDictTypes()
            .then((res) => {
                const transportTypes = res.transportTypes;
                if (transportTypes.length === 0) {
                    return;
                }
                const transportTypesWithSteps = [...transportTypes, { name: "Kroki", transportId: "-1" }];
                this.setState(
                    {
                        transportTypes: transportTypesWithSteps,
                    },
                    () => {
                        this.fatchRanking(this.getRankingCleanSearchCriteria());
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage('Nie można typów transportu');
            });
    };
    fetchMonthTravelKilometers = () => {
        this.statisticService
            .getKilometersTraveledMonth()
            .then((res) => {
                this.setState({monthTravelKilometers: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych transportu');
            });
    };
    fetchSavedCo2 = () => {
        this.statisticService
            .getSavedCo2Month()
            .then((res) => {
                this.setState({monthSavedCo2: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych zaoszczedzonego CO2');
            });
    };
    fetchMonthFinishedChallengesCount = () => {
        this.statisticService
            .getFinishedChallengesCountInMonth()
            .then((res) => {
                this.setState({monthFinishedChallengesCount: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych transportu');
            });
    };
    fetchKilometerGroupByMonths = () => {
        this.statisticService
            .getChartKilometersTraveledByMonth()
            .then((res) => {
                this.setState({kilometersGroupedByMonths: res.content});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk miesięcznych transportu');
            });
    };
    fetchSavedCo2GroupByMonths = () => {
        this.statisticService
            .getChartSavedCo2ByMonth()
            .then((res) => {
                this.setState({savedCo2GroupedByMonths: res.content});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk miesięcznych zaoszczedzonego CO2');
            });
    };
    fetchTodayCoordinates = () => {
        this.blockUi();
        this.statisticService
            .getTodayCoordinates()
            .then((res) => {
                this.setState({todayRoutes: res.userTransports, renderMap: true});
                this.unblockUi();
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać dzisiejszych koordynatów');
            });
    };

    fatchRanking(criteria) {
        // Dodaj parametr activityType=STEPS jeśli wybrano "Kroki"
        if (
            (criteria.transportId && criteria.transportId === "-1") ||
            (criteria.name && criteria.name === "Kroki")
        ) {
            criteria.activityType = "STEPS";
        } else {
            // Usuwamy activityType jeśli nie są to kroki, by nie wysyłać go niepotrzebnie
            delete criteria.activityType;
        }

        this.rankingService
            .getRanking(criteria)
            .then((data) => {
                this.setState({
                    rankingPageable: data,
                });
            })
            .catch(() => {
                this.showErrorMessage('nie można pobrać rankingu');
            });
    }

    getRankingCleanSearchCriteria() {
        return {
            transportId: this.state.transportTypes[0].transportId,
            date: new Date(),
            firstResult: 0,
            type: 'TRAVELED_DISTANCE',
            maxResults: 10,
        };
    }

    breadCrumbItems() {
        return [];
    }

    showFullScreenMap = () => {
        this.setState({ fullScreenMapVisible: true });
    }

    hideFullScreenMap = () => {
        this.setState({ fullScreenMapVisible: false });
    }
    render() {
        return (
            <React.Fragment>
                <CompanyAgreementBanner />
                <BaseBreadCrumb items={this.breadCrumbItems()} />
                <BlockUi tag='div' blocking={this.state.blocking} loader={this.loader}>
                    <div className='row'>
                        <div className='col-lg-6'>
                            {this.state.renderMap && (
                                <DashboardCardMapComponentV2 
                                    initialRoutes={this.state?.todayRoutes} 
                                    title={t('dashboard.title')} 
                                    onFullScreenMap={this.showFullScreenMap}
                                />
                            )}
                            {this.state?.kilometersGroupedByMonths && (
                                <DashboardCardChartComponent
                                    dataSetLabel='km'
                                    backgroundColor='#1e325c'
                                    initialChartData={this.state?.kilometersGroupedByMonths}
                                    title={t('dashboard.km-in-month')}
                                />
                            )}
                        </div>
                        <div className='col-lg-6'>
                            {this.state.transportTypes.length !== 0 && (
                                <DashboardRankComponent
                                    transportTypes={this.state.transportTypes}
                                    rankingTitle={'Ranking'}
                                    myPlaceTitle={'Moje miejsce'}
                                    rankingPageable={this.state.rankingPageable}
                                    rows={5}
                                    rowsPerPageOptions={[5, 10, 20]}
                                    fatchRanking={(criteria) => {
                                        this.fatchRanking(criteria);
                                    }}
                                    getRankingCleanSearchCriteria={() => {
                                        return this.getRankingCleanSearchCriteria();
                                    }}
                                />
                            )}

                            <div className='row'>
                                <div className='col-lg-6'>
                                    <DashboardCardMonthComponent
                                        resultValueColor='#1e325c'
                                        resultValue={this.state?.monthTravelKilometers?.currentMonthValue}
                                        percentageDeviation={this.state?.monthTravelKilometers?.percentageDeviationByPrevMonth}
                                        title={t('dashboard.km-monthly')}
                                        imageHref={AppPrefixUtils.locationHrefUrl(`/images/distance.png`)}
                                        unit='km'
                                    />
                                </div>
                                <div className='col-lg-6'>
                                    <DashboardCardMonthComponent
                                        resultValueColor='#008000'
                                        resultValue={this.state?.monthSavedCo2?.currentMonthValue}
                                        percentageDeviation={this.state?.monthSavedCo2?.percentageDeviationByPrevMonth}
                                        title={
                                            <div>
                                                {t('dashboard.saved')} CO<sub>2</sub> {t('dashboard.this-month')}
                                            </div>
                                        }
                                        unit='kg'
                                        imageHref={AppPrefixUtils.locationHrefUrl(`/images/activity.png`)}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-6'></div>
                            {this.state?.savedCo2GroupedByMonths && (
                                <React.Fragment>
                                    <DashboardCardChartComponent
                                        resultValue={250}
                                        dataSetLabel='Kg'
                                        backgroundColor='#008000'
                                        initialChartData={this.state?.savedCo2GroupedByMonths}
                                        percentageDeviation={20}
                                        title={
                                            <div>
                                                {t('dashboard.saved')} CO<sub>2</sub>
                                            </div>
                                        }
                                    />
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </BlockUi>
                <FullScreenMapDialog
                    visible={this.state.fullScreenMapVisible}
                    onHide={this.hideFullScreenMap}
                    header={t('dashboard.title')}
                >
                    <FullScreenMapComponent initialRoutes={this.state?.todayRoutes || []} />
                </FullScreenMapDialog>
            </React.Fragment>
        );
    }
}

DashboardContainer.propTypes = {};
export default withRouter(withTranslation()(DashboardContainer));
